<!-- Start Main Banner Area -->
<div class="main-banner-area">
    <div class="container">
        <h3 style="text-align: center;color: white;">WE'RE YOUR COMPASS, GUIDING YOU TO NEW OPPORTUNITIES</h3>
        <div class="listings-slides">
            <owl-carousel-o [options]="customOptions">
                <ng-template carouselSlide *ngFor="let Content of businessDetailsList;">
                    <div class="single-listings-box">
                        <div class="listings-image">
                            <div class="listings-image-slides">
                                <owl-carousel-o [options]="customOptions2">
                                    <ng-template carouselSlide *ngFor="let Image of Content.uploadedFilesName;;">
                                        <div class="single-image">
                                            <img [src]="Image" alt="image" style="height: 260px;">
                                            <!-- <a routerLink="/{{Content.detailsLink}}" class="link-btn"></a> -->
                                            <a  class="link-btn"></a>
                                        </div>
                                    </ng-template>
                                </owl-carousel-o>
                            </div>
                            <a 
                            (click)="isPublicUser == true ? userToken() : selectBusinessForListing(Content)"
                             id="savemark" class="bookmark-save">
                                <i class="flaticon-heart" [ngClass]="{'favorite': Content.IsfavoriteBusiness}"></i>
                            </a>
                            <!-- <a  (click)="selectBusinessForListing(Content)" id="savemark"  class="bookmark-save"><i class="flaticon-heart"></i></a> -->
                            <!-- <a routerLink="/{{Content.categoryLink}}" class="category"><i class="flaticon-cooking"></i></a> -->
                            <a class="category"><i class="flaticon-cooking"></i></a>
                        </div>
                        <div class="listings-content">
                            <div class="author">
                                <div class="d-flex align-items-center">
                                    <!-- <img [src]="Content.authorImg" alt="image" > -->
                                    <!-- <span>{{Content.authorName}}</span> -->
                                    <span>Salman</span>

                                </div>
                            </div>
                            <div class="author-2">

                                <div class="d-flex align-items-center">
                
                                  <img
                
                                  [src]="(Content.LOGO_PICTURE && Content.LOGO_PICTURE.trim() !== '') ? Content.LOGO_PICTURE : 'assets/images/no-avatar.png'"                
                                    alt="image"
                
                                    class="profile-img"
                
                                    (click)="openPopup(Content.LOGO_PICTURE)"
                
                                  />
                
                                </div>
                
                              </div>
                            <ul class="listings-meta">
                                <li><a routerLink="/single-listings"><i class="flaticon-furniture-and-household"></i> {{Content.BUSINESS_CATEGORY}}</a></li>

                                <!-- <li><a routerLink="/{{Content.categoryLink}}"><i class="flaticon-furniture-and-household"></i> {{Content.BUSINESS_CATEGORY}}</a></li> -->
                                <li><i class="flaticon-pin"></i> {{Content.BUSINESS_ADDRESS}}</li>
                            </ul>
                            <h3><a (click)="selectBusiness(Content)">{{Content.BUSINESS_NAME}}</a></h3>
                            
                            <button class="follow-btn mb-3" 
                            (click)="isPublicUser == true ? userToken() : followBusiness(Content.BUSINESS_DETAIL_ID)"
                            >
                                {{ Content.IsFollow ? 'Following' : 'Follow' }}

                            </button>

                            <!-- <h3><a routerLink="/{{Content.detailsLink}}">{{Content.BUSINESS_NAME}}</a></h3> -->
                            <span class="status {{'status-open'}}"><i class="flaticon-save"></i> Open Now</span>
                            <!-- <span class="status {{Content.extraClass}}"><i class="flaticon-save"></i> {{Content.openORclose}}</span> -->
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="rating">
                                    <!-- <i class='{{Star.icon}}' *ngFor="let Star of Content.rating;"></i>
                                    <span class="count">({{Content.ratingCount}})</span> -->
                                    <!-- <i class='{{Star.icon}}' *ngFor="let Star of Content.rating;"></i> -->
                                    <span *ngFor="let star of [].constructor(Content.fullStars)" class="bx bxs-star full-star"></span>

                                    <!-- Half Star (if any) -->
                                    <span *ngIf="Content.halfStar" class="bx bxs-star-half full-star"></span>

                                    <!-- Empty Stars -->
                                    <span *ngFor="let star of [].constructor(Content.emptyStars)" class="bx bxs-star empty-star"></span>
                                    <!-- <span class="count">({{Content.ratingCount}})</span> -->
                                </div>
                                <div class="price">
                                    <!-- {{Content.price}} -->
                                    200

                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- End Main Banner Area -->

<div

  class="popup-overlay"

  [ngClass]="{ visible: isPopupVisible }"

  (click)="closePopup()"

>

  <div class="popup" [ngClass]="{ visible: isPopupVisible }">

    <span class="close-btn" (click)="closePopup()">&times;</span>

    <img src="{{selectedImagePath}}" alt="image" class="popup-img" />

  </div>

</div>


<div class="custom-modal" *ngIf="isTermsVisible">
    <div class="popup-overlay" (click)="closePopup()"></div>
    <div class="modal-content" style="max-height: 400px; overflow-y: auto;">
        <div class="terms-header">
            <h2 class="terms-title" style="text-align: center;">Terms and Conditions</h2>
        </div>
        <div class="terms-body" >
            <p style="color: aliceblue;">These Terms of Service ("Agreement") govern the use of the advertising website ("Xploradoor") and the services provided by the website owner. By accessing or using the Website, you Xplorers agree to be bound by these Terms of Service. If you do not agree with any part of these Terms of Service, you must refrain from using the Website.</p>
            
            <p style="color: aliceblue;"><strong>1. Acceptance of Terms</strong></p>
            <p style="color: aliceblue;">a. Users must be at least 18 years old or have legal parental or guardian consent to use the Website.</p>
            <p style="color: aliceblue;">b. By accessing or using the Website, users acknowledge that they have read, understood, and agree to be bound by these Terms of Service, as well as any additional guidelines or rules applicable to specific services or features provided by the Website.</p>
            
            <!-- Include the rest of the terms as formatted paragraphs. -->

            <p style="color: aliceblue;"><strong>10. Governing Law and Jurisdiction</strong></p>
            <p style="color: aliceblue;">These Terms of Service shall be governed by and construed in accordance with the laws of the US. Any legal action or proceeding arising out of or in connection with these Terms of Service shall be brought in the courts of the US.</p>

            <p style="color: aliceblue;"><strong>11. Severability</strong></p>
            <p style="color: aliceblue;">If any provision of these Terms of Service is deemed invalid or unenforceable, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.</p>

            <p style="color: aliceblue;">By using the Website, the User acknowledges and agrees to abide by these Terms of Service. I as a business owner or an xplorer will accept the terms of service above.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeTerms()">Cancel</button>
            <button class="accept-btn" (click)="closePopupAccept()">Accept</button>
        </div>
    </div>
</div>






